export const locale = process.env.VUE_APP_LOCALE;
export const fallbackLocale = process.env.VUE_APP_FALLBACK_LOCALE;